import { styled, Box, Typography } from '@mui/material';

export const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCursorPointer',
})<{ isCursorPointer?: boolean }>(({ theme, isCursorPointer: isCursorPointer }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  cursor: isCursorPointer ? 'pointer' : 'default',
}));

export const StyledImageContainer = styled(Box)(({ theme }) => ({
  width: 104,
  height: 104,
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  overflow: 'hidden',
}));

export const StyledImage = styled('img')({
  maxWidth: '104px',
  maxHeight: '104px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
});

export const StyledPlaceholder = styled(Box)(({ theme }) => ({
  width: 104,
  height: 104,
  backgroundColor: theme.palette.ui?.background,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledContentContainer = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const StyledTagsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
